module.exports = __webpack_public_path__ + "static/media/sopt29kz.a59d1e27.pdf";